import React from 'react'

import { Color, withCitrusTheme } from '@gousto-internal/citrus-react'

// White links, underlined on hover/focus. Hover re-asserts white to beat Bootstrap's global a:hover.
const sharedLinkStyle = (theme: any) => [
  {
    color: theme.color(Color.White),
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover, &:focus': {
      color: theme.color(Color.White),
      textDecoration: 'underline',
    },
  },
  theme.responsiveStyle(['14px', null, null, '16px'], ['fontSize']),
  theme.responsiveStyle(['20px', null, null, '24px'], ['lineHeight']),
]

const FooterAnchor = withCitrusTheme('a', sharedLinkStyle)

const FooterButton = withCitrusTheme('button', (theme) => [
  ...sharedLinkStyle(theme),
  {
    appearance: 'none',
    background: 'none',
    border: 0,
    padding: 0,
    textAlign: 'left',
    fontFamily: 'inherit',
  },
])

type FooterLinkProps = {
  children: React.ReactNode
  href?: string
  onClick?: () => void
  title?: string
  testid?: string
  optimizely?: string
}

export const FooterLink = ({
  children,
  href,
  onClick,
  title,
  testid,
  optimizely,
}: FooterLinkProps) =>
  href ? (
    <FooterAnchor
      href={href}
      onClick={onClick}
      title={title}
      data-testid={testid}
      data-optimizely={optimizely}
    >
      {children}
    </FooterAnchor>
  ) : (
    <FooterButton type="button" onClick={onClick} title={title} data-testid={testid}>
      {children}
    </FooterButton>
  )
